export default "__VITE_ASSET__B_EFRtA4__"